module.exports = "/images/Mailchimp.svg?f0f6eaade0dbfaa4fb2585b4bc42e08b";